export const LinkProduct = [
    {
        data_product : 'Accessories',
        name : 'Accessories'
    },
    {
        data_product : 'Sofa',
        name : 'Sofa'
    },
    {
        data_product : 'Chairs & Stools',
        name : 'Chairs & Stools'
    },
    {
        data_product : 'Table',
        name : 'Table'
    },
    {
        data_product : 'Lighting',
        name : 'Lighting'   
    },
    {
        data_product : 'Furnishings',
        name : 'Furnishings'
    }
]
